import PropTypes from 'prop-types'

/**
 * @param {string} color - color of the Icon.
 * @returns {React.ReactNode} - return a Restart Icon. 
 */

export function Restart(props) {

    const { color = "currentColor"} = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
            <path d="M6.13795 2.99464C9.25836 1.27408 13.1406 1.82474 15.6594 4.34518C15.6666 4.35234 15.6738 4.35938 15.6812 4.36632L18.4762 6.9983H14.9967C14.4445 6.9983 13.9967 7.44601 13.9967 7.9983C13.9967 8.55058 14.4445 8.9983 14.9967 8.9983H20.9967C21.1371 8.9983 21.2708 8.96937 21.392 8.91715C21.5133 8.86505 21.6262 8.78794 21.7227 8.68606C21.7312 8.67708 21.7395 8.66794 21.7477 8.65865C21.9143 8.46949 21.9968 8.23367 21.9968 7.99831L21.9967 7.99607V1.9983C21.9967 1.44601 21.549 0.998299 20.9967 0.998299C20.4445 0.998299 19.9967 1.44601 19.9967 1.9983V5.68302L17.0631 2.92044C13.9142 -0.220739 9.06822 -0.904965 5.17225 1.24324C1.27174 3.39394 -0.736109 7.86513 0.247816 12.2093C1.23174 16.5534 4.97021 19.7231 9.41677 19.9832C13.8633 20.2433 17.9459 17.5312 19.4296 13.3314C19.6136 12.8107 19.3406 12.2394 18.8199 12.0554C18.2991 11.8714 17.7278 12.1444 17.5439 12.6652C16.3569 16.025 13.0908 18.1947 9.53357 17.9866C5.97632 17.7785 2.98555 15.2428 2.19841 11.7675C1.41127 8.29216 3.01754 4.7152 6.13795 2.99464Z" fill={color} />
        </svg>
    );

}

Restart.propTypes = {
    color: PropTypes.string
}